// extracted by mini-css-extract-plugin
export default {"donation":"UserProfilePage_donation__7CECA","tabel":"UserProfilePage_tabel__0QYQG","cell":"UserProfilePage_cell__aA1Tv"};